import React from "react";
import { MenuItem } from "../../menu-item";
import DropdownArrow from "../../../../../assets/icons/dropdown";

import "./top-bar.m.css";

export const DesktopNavItem = ({ item, isOpen, onToggle }) => {
  const handleToggle = (e) => {
    if (item.children?.length > 0) {
      e?.preventDefault();
      e?.stopPropagation();
      onToggle();
    }
  };

  // Move renderDropdown logic to a const
  const dropdownContent = (() => {
    if (!item.children?.length) return null;
    const hasNested = item.children.some(c => c.children?.length > 0);

    if (hasNested) {
      return (
        <div styleName="dropdown-menu has-nested">
          <div styleName="nested-dropdown-container">
            {item.children.map((child, i) => {
              // If child has children, render as a column with sub-items
              if (child.children?.length > 0) {
                return (
                  <div key={`${child.title}-${i}`} styleName="dropdown-column sub-column">
                    <h3 styleName="column-title">
                      <MenuItem item={child} menuStyle="dropdown-link" />
                    </h3>
                    <ul styleName="dropdown-list">
                      {child.children.map((subChild, i) => (
                        <li key={`${subChild.title}-${i}`} styleName="dropdown-item">
                          <MenuItem item={subChild} menuStyle="dropdown-link" />
                        </li>
                      ))}
                    </ul>
                  </div>
                );
              }
              // If child has no children, render as a standalone item with same structure
              return (
                <div key={child.title} styleName="dropdown-column sub-column">
                  <h3 styleName="column-title">
                    <MenuItem item={child} menuStyle="dropdown-link" />
                  </h3>
                </div>
              );
            })}
          </div>
        </div>
      );
    }

    return (
      <div styleName="dropdown-menu">
        <ul styleName="dropdown-list">
          {item.children.map((child, i) => (
            <li key={`${child.title}-${i}`} styleName="dropdown-item">
              <MenuItem item={child} menuStyle="dropdown-link" />
            </li>
          ))}
        </ul>
      </div>
    );
  })();

  return (
    <div styleName={`nav-item ${isOpen ? "open" : ""}`} role="button" aria-expanded={isOpen}>
      <div styleName="nav-item-wrapper" onClick={handleToggle}>
        <MenuItem item={item} menuStyle="nav-link" toggleHandler={handleToggle} />
        {item.children?.length > 0 && (
          <div styleName="dropdown-icon">
            <DropdownArrow />
          </div>
        )}
      </div>
      {dropdownContent}
    </div>
  );
};
